import Box from '@mui/material/Box';

export const UnknownComponent = ({ name }: { name: string }) => {
  if (process.env.STAGE_ENV === 'live') return null;

  return (
    <Box sx={{ p: 1, border: '1px dashed red' }}>Unkown Component: {name}</Box>
  );
};
